var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Certificat-authority-main",class:{ 'Certificat-authority-main-mobile': _vm.isMobile}},[_c('Base-title',{attrs:{"title":"权威认证 值得信赖 "}}),_c('CertificatType')],1)}
var staticRenderFns = []

export { render, staticRenderFns }